module.exports = __webpack_public_path__ + "img/bae0ea4ab73b7c50e82700b21b5c26f3.png";